import React from 'react';
import { paymentSchedule, type Tier } from '../lib/quoteEstimator';

/**
 * Commercial terms for a completed development estimate only.
 * Not shown on Contact, and not shown on /pricing before the estimate exists.
 * Payment percentages are the published schedule — not a change to tier prices.
 */
const CommercialTerms: React.FC<{ tier?: Tier; compact?: boolean; id?: string }> = ({ tier, compact = false, id = 'commercial-terms' }) => (
  <section id={id} aria-labelledby={`${id}-heading`} className="panel p-4 sm:p-5">
    <h2 id={`${id}-heading`} className="text-lg font-bold text-white">
      Commercial terms
    </h2>
    <p className="mt-2 text-sm text-secondary-300">
      {tier ? (
        <>
          For this estimate ({tier}): {paymentSchedule(tier)}
        </>
      ) : (
        <>
          T1 and T2: 50% upfront, 50% at completion. T3A, T3B, and T4A: 40% upfront, 40% at three-fifths development completion, and 20% upon completion. T4B and T5: FairCorp retains the right to specify payment terms during official quoting.
        </>
      )}
    </p>
    {!compact && (
      <ul className="mt-3 list-disc pl-5 space-y-1.5 text-sm text-secondary-300">
        <li>You may be delivered all of your code and data at any point during development or the hosting contract.</li>
        <li>Contracts are not binding and may be cancelled at any time.</li>
        <li>If you withdraw, the codebase is scrubbed of internal linkage to FairCorp or FairCorp internal systems.</li>
        <li>FairCorp may deny a quote or deny service when a request is outside our capability or conflicts with company ethics.</li>
      </ul>
    )}
    {compact && (
      <p className="mt-2 text-sm text-secondary-300">
        You may be delivered all of your code and data at any point during development or the hosting contract. Contracts are not binding and may be cancelled at any time. On withdrawal, the codebase is scrubbed of internal linkage to FairCorp or FairCorp internal systems. FairCorp may deny a quote or deny service when a request is outside our capability or conflicts with company ethics.
      </p>
    )}
  </section>
);

export default CommercialTerms;
